<template>
<v-container fluid>
    <v-row>
        <v-col>
            <h4 class="text-h4">Credit Notes</h4>
            <p class="text-subtitle-1">List of supplier credit notes</p>
            <v-divider></v-divider>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="12" md="3" v-if="hasPermission(perm.credit_note.create)">
            <v-btn color="primary" block @click="handleNew" >
                <v-icon left>mdi-plus</v-icon>
                new credit note
            </v-btn>
        </v-col>
        <v-col cols="12" md="3">
            <v-menu offset-y :close-on-content-click="false" min-width="300">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        depressed
                        block
                        >
                        <v-icon left>mdi-magnify</v-icon>
                        search
                    </v-btn>
                </template>
                <v-card 
                    flat
                    >
                    <v-card-title>Search</v-card-title>
                    <v-card-text>
                        <CreditNoteListSearch ref="form"/>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary" depressed block @click="$refs.form.submit()">Submit</v-btn>
                    </v-card-actions>
                </v-card>
            </v-menu>
        </v-col>
    </v-row>
    <v-row>
        <v-col>
            <CreditNoteList/>
        </v-col>
    </v-row>
</v-container>
</template>

<script>
import permissions from './../../data/permissions';
import CreditNoteListSearch from "./../../components/purchase/CreditNoteListSearch"
import CreditNoteList from "./../../components/purchase/CreditNoteList.vue"
import { mapActions, mapGetters } from 'vuex'
export default {
    name: "CreditNoteListView",
    components: {
        CreditNoteList,
        CreditNoteListSearch
    },
    data() {
        return {
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            search: "purchase/creditNote/search"
        }),
        handleNew() {
            this.$router.push({ name: "CreditNoteCreate"})
        },
        handleRefresh() {
            this.search();
        }
    }
}
</script>

<style>

</style>